import axios from 'axios';
import config from '../config';

const BACKEND_URL = config.api.url;
const BASE_URL = `${BACKEND_URL}/api/auth`;

// Configuration d'axios avec timeout
const axiosInstance = axios.create({
  timeout: config.api.timeout,
});

export interface LoginResponse {
  token: string;
  message: string;
}

export interface AuthUser {
  token: string;
}

export const login = async (password: string): Promise<LoginResponse> => {
  const response = await axiosInstance.post(`${BASE_URL}/login`, { password });
  return response.data;
};

export const verifyToken = async (token: string): Promise<boolean> => {
  try {
    await axiosInstance.get(`${BASE_URL}/verify`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return true;
  } catch (error) {
    return false;
  }
};

// Configuration d'axios pour inclure automatiquement le token
export const configureAxiosAuth = (token: string) => {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
};

export const clearAxiosAuth = () => {
  delete axios.defaults.headers.common['Authorization'];
};
